/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
 
import dayjs from "dayjs";

export function formatDate (dateObj, formatStr) {
    if (!(dateObj instanceof Date)) {
        throw new Error("The first parameter must be a Date object.");
    }
    return dayjs(dateObj).format(formatStr);
}

export function getMonthAndDay (dateStr) {
    const date = dayjs(dateStr);
    return {
        day: date.format("DD"),
        month: date.format("MMMM")
    };
}

